"use strict";

require("./dialogs/loading/loading-dialog.controller");
require("./dialogs/analysis-plus/analysis-plus-dialog.controller");
require("./dialogs/analysis-plus-request-plan/analysis-plus-request-plan-dialog.controller");
require("./dialogs/activate-analysis-plus/activate-analysis-plus-dialog.controller");
require("./dialogs/request-confirm-analysis-plus/request-confirm-analysis-plus-dialog.controller");
require("./dialogs/request-licenses/request-licenses-dialog.controller");
require("./dialogs/apply-licenses/apply-licenses-dialog.controller");
